<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingCategories"/>

    <form-group :label="$t('maxInstallment.label')" :columns="3" :error="getError('maxInstallment', product.productId)" :required="true">
      <input class="form-input" type="text" v-model="product.maxInstallment">
    </form-group>

    <form-group :label="$t('warranty.label')" :error="getError('warranty', product.productId)" :required="true">
      <input type="number" class="form-input" v-model="product.warrantyTime">
    </form-group>

    <div class="l-col-12@md">
      <div class="l-row">
        <form-group :label="$t('department.label')" :columns="3" :error="getError('department', product.productId)" :required="true">
          <multiselect
            v-model="department"
            :options="departments"
            selectLabel=""
            selectedLabel=""
            placeholder="Escolha"
            label="label"
            track-by="label"
          />
        </form-group>

        <form-group :label="$t('sector.label')" :columns="3" :error="getError('sector', product.productId)" :required="true" v-if="department">
          <multiselect
            v-model="sector"
            :options="departments.find(dp => dp.code === department.code).sectors"
            selectLabel=""
            selectedLabel=""
            placeholder="Escolha"
            label="label"
            track-by="label"
          />
        </form-group>

        <form-group :label="$t('family.label')" :columns="3" :error="getError('family', product.productId)" :required="true" v-if="sector">
          <multiselect
            v-model="family"
            :options="departments.find(dp => dp.code === department.code).sectors.find(st => st.code === sector.code).families"
            selectLabel=""
            selectedLabel=""
            placeholder="Escolha"
            label="label"
            track-by="label"
          />
        </form-group>
      </div>
    </div>
  </shared-product-provide>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'ricardoEletro'
      },
      maxDescriptionLengthDI: 65000,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingCategories: false,
      departments: [],
      department: null,
      sector: null,
      family: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      if (this.product.description.length > 65000) {
        this.product.description = this.product.description.substr(0, 65000)
      }

      this.product.maxInstallment = this.moduleDefinition.module.configs.product.maxInstallment || 0

      this.loadingCategories = true
      api.getCategories('marketplace', 'ricardoEletro')
        .then(departments => {
          this.departments = departments
          this.product.department = ''

          const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
          if (presetCategorization !== null && presetCategorization !== undefined) {
            this.department = this.departments.find(category => category.code === presetCategorization.category)
          }
        })
        .catch(() => {
          notifier.error('Impossível carregar as categorias do Ricardo Eletro.', 'Erro')
        })
        .finally(() => {
          this.loadingCategories = false
        })
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            return {
              sku: variation.sku,
              title: this.product.title,
              description: this.product.description,
              stock: variation.stock,
              price: variation.price,
              source: this.fromModule,
              ean: variation.ean,
              images: variation.images.length ? variation.images : null,
              width: variation.width,
              height: variation.height,
              weight: variation.weight,
              length: variation.length,
              departmentId: this.department ? this.department.code : null,
              sectorId: this.sector ? this.sector.code : null,
              familyId: this.family ? this.family.code : null,
              brand: this.product.brand,
              maxInstallment: this.product.maxInstallment,
              manufacturerReference: variation.manufacturerReference,
              productId: this.product.productId,
              color: variation.attributes.color !== undefined && variation.attributes.color !== '' && variation.attributes.color !== null ? variation.attributes.color : 'Única',
              grid: this.getGrid(variation),
              gridType: this.getType(variation),
              gender: variation.gender,
              warrantyTime: this.product.warrantyTime,
              crossDocking: {
                quantity: variation.crossDocking
              },
              original: {
                product: this.product,
                variation: variation
              }
            }
          }
        )
      },
      getType (variation) {
        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return 'Único'
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError',
        'getErrors'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'ricardoEletro')
      }
    },
    watch: {
      department () {
        this.sector = null
      },
      sector () {
        this.family = null
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?c78cc468